import React from 'react';
import { FaArrowRight, FaMapMarkerAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import '../css/walkingHikingTours.css'; // Import custom styles
import NavBar from './nav';
import Footer from './footer';
import { findJourneyItem } from './journeyData';

const NaturalExperiences = () => {
  const navigate = useNavigate();
  // List of natural experiences around Kimberley
  const naturalExperiences = [
    {
      slug: "kamfers-dam",
      name: "Kamfers Dam",
      description: "Kamfers Dam is a haven for bird watchers, home to thousands of flamingos. The walking trails around the dam offer stunning views and a peaceful atmosphere.",
      image: require("../assets/KamferDam.jpg"), // Replace with actual image path  
    },
    {
      slug: "the-big-hole-walks",
      name: "The Big Hole",
      description: "The Big Hole is a massive man-made excavation and one of the deepest holes in the world. It's a must-visit for history and diamond enthusiasts.",
      image: require("../assets/Fallback/Big Hole/bigHole04.jpg"),
    },
    {
      slug: "rooipoort-nature-reserve",
      name: "Rooipoort Nature Reserve",
      description: "Rooipoort offers rugged hiking trails through pristine wilderness, with opportunities to spot wildlife like antelopes, zebras, and a variety of bird species.",
      image: require("../assets/PL-RooiPoort.jpg"),
    },
    {
      slug: "magersfontein-battlefield",
      name: "Magersfontein Battlefield",
      description: "This historical site offers walking trails that take you through the battlefield, providing insights into the Anglo-Boer War while enjoying the natural beauty of the area.",
      image: require("../assets/Fallback/Magersfontein Battlefield/magersfonteinBattlefield05.jpg"),
    },
    {
      slug: "william-humphreys-gallery-gardens",
      name: "William Humphreys Art Gallery Gardens",
      description: "The gardens surrounding the William Humphreys Art Gallery are a serene escape, featuring beautiful landscapes and sculptures.",
      image: require("../assets/william.jpg"),
    }
  ];

  const openDetails = (experience) => {
    const item = findJourneyItem(experience.slug);
    navigate(`/journey/${experience.slug}`, { state: { item } });
  };

  return (
    <div>
      <NavBar />
      
      {/* Hero Section */}
      <div className="hero-section">
        <h1 className="hero-title">Experience Nature Around Kimberley</h1>
        <p className="hero-subtitle">Discover the beauty of Kimberley's natural wonders, from serene dams to historical landmarks.</p>
      </div>

      {/* Natural Experiences Section */}
      <div className="walking-hiking-tours">
        <h1 className="section-title">Natural Experiences Around Kimberley</h1>
        <p className="section-subtitle">Explore the best natural attractions Kimberley has to offer.</p>
        
        <div className="hiking-spots-grid">
          {naturalExperiences.map((experience, index) => (
            <div key={index} className="hiking-spot-card">
              <div className="hiking-spot-image-container">
                <img src={experience.image} alt={experience.name} className="hiking-spot-image" />
                <span className="hiking-card-chip">
                  <FaMapMarkerAlt /> Kimberley
                </span>
              </div>
              <div className="hiking-spot-content">
                <span className="hiking-card-kicker">Experience {index + 1}</span>
                <h2 className="hiking-spot-name">{experience.name}</h2>
                <p className="hiking-spot-description">{experience.description}</p>
                <button type="button" className="visit-button" onClick={() => openDetails(experience)}>
                  Learn More <FaArrowRight />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default NaturalExperiences;
